module.exports = __webpack_public_path__ + "286d3e78f21acc6cdf446acf1c27d479.png";